import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as hookActions from 'checkout/actions/hooks';
import { toDecimals } from '../../helpers/currency';
import { getOrderTotal } from '../../selectors/cart';


export class Adroll extends Component {
    reportEvent = (type, args) => {
      const { adv_id, pix_id } = this.props.config;
      this.props.reportEvent(`${adv_id}/${pix_id}`)(type, args);
    }

    constructor(props) {
        super(props);
        //addToCart
        this.props.addTicketsAddedToCartHook(this.onTicketsAdded);
        this.props.addProductsAddedToCartHook(this.onProductsAdded);
        this.props.addBundlesAddedToCartHook(this.onBundlesAdded);

        //purchase
        this.props.addReservationCompleteHook(this.onReservationComplete);
    }

    render() {
        return null;
    }

    onTicketsAdded = tickets => {
        this.reportEvent('addToCart', {
            "currency": this.props.currency,
            "products": tickets.map(item => this.formatItem(item, 'ticket')),
        });
    }

    onProductsAdded = products => {
        this.reportEvent('addToCart', {
            "currency": this.props.currency,
            "products": products.map(item => this.formatItem(item, 'product')),
        });
    }

    onBundlesAdded = bundles => {
        this.reportEvent('addToCart', {
            "currency": this.props.currency,
            "products": bundles.map(item => this.formatItem(item, 'bundle')),
        });
    }

    onReservationComplete = () => {
        const reservationSessionKey = `adroll_purchase_${this.props.confirmationNumber}`;
        const sent = sessionStorage.getItem(reservationSessionKey);
        if (!sent) {
            // purchase event
            this.reportEvent('purchase', {
                "order_id": this.props.confirmationNumber,
                "currency": this.props.currency,
                "conversion_value": toDecimals({amount: this.props.orderTotal, currency: this.props.currency}),
                "products": this.formatAllReservationItems()
            });
            sessionStorage.setItem(reservationSessionKey,'1');
        }
    }


    formatAllReservationItems = () => {
        const items = [];
        this.props.tickets.forEach(ticket => {
            items.push(this.formatItem(ticket, 'ticket'));
        });
        this.props.productSales.forEach(product => {
            items.push(this.formatItem(product, 'product'));
        });
        this.props.bundleSales.forEach(bundle => {
            items.push(this.formatItem(bundle, 'bundle'));
        });
        return items;
    }

    formatItem = (item, type) => {
        const itemIdFieldMap = {
            ticket : 'price_level_id',
            product: 'product_id',
            bundle : 'bundle_id',
        };

        const itemNameFieldMap = {
            ticket : 'price_level_name',
            product: 'product_name',
            bundle : 'name',
        };
        return {
            product_id: item?.[itemIdFieldMap[type]] + '',
            product_group: item?.[itemNameFieldMap[type]] + '',
            quantity: 1,
            price: toDecimals({amount: +item?.cost?.amount + +item?.buyer_fee?.amount, currency: this.props.currency}),
            category: type,
        };
    }
}

const mapStateToProps = state => {
    return {
        confirmationNumber: state.reservation.confirmation_number,
        currency: state.reservation.currency || 'USD',
        orderTotal: getOrderTotal(state)?.amount ?? 0,
        tickets: state.tickets.tickets,
        productSales: state.productSales.products,
        bundleSales: state.bundleSales.bundles,
    }
}

const mapDispatchToProps = dispatch => {
    const actions = {};
    Object.keys(hookActions).forEach(hookActionName => {
        actions[hookActionName] = hookActions[hookActionName];
    });
    return bindActionCreators(actions, dispatch);
}

Adroll.propTypes = {
    config: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(Adroll)
